import React from "react";

import { Box } from "../../../shared/components/ui/chakra";
import { BoxProps } from "@chakra-ui/react";

const BusinessEntityDottedLine = (props?: BoxProps) => {
  return (
    <Box
      w="full"
      height="1px"
      bg="repeating-linear-gradient(to right, var(--chakra-colors-brand-300) 0px, var(--chakra-colors-brand-300) 4px, transparent 4px, transparent 8px)"
      {...props}
    />
  );
};

export default BusinessEntityDottedLine;
